import { useEffect } from "react";
import classNames from "classnames/bind";
import { GalleryObject } from "../utils/utils.ts";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import { dispatchGalleryMonetateQEvent } from "@/components/Galleries/components/Analytics/dispatchGalleryMonetateQEvent";
import styles from "./Thumbnails.module.scss";

const cx = classNames.bind(styles);

type ThumbnailProps = {
  media: GalleryObject[];
  selectedIndex: number;
  scrollImagesToIndex: (index: number) => void;
  scrollThumbnailsToIndex: (index: number) => void;
  autoScroll: boolean;
  ref: React.RefObject<HTMLDivElement | null>;
};

export const Thumbnails = ({
  ref,
  media,
  selectedIndex,
  scrollImagesToIndex,
  scrollThumbnailsToIndex,
  autoScroll,
}: ThumbnailProps) => {
  const modalMode = media[0]?.type === "video" ? "videoModal" : "imageModal";

  useEffect(() => {
    if (!autoScroll) {
      scrollThumbnailsToIndex(selectedIndex);
    }
  }, [selectedIndex]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.thumbnails} ref={ref}>
        {media.map((mediaItem, ind) => (
          <div
            key={`${mediaItem.imageUrl}-${ind}`}
            className={cx(styles.thumbnailItem, {
              selected: ind === selectedIndex && !autoScroll,
            })}
          >
            <button
              className={cx(styles.thumbnailItemButton, {
                video: mediaItem.type === "video",
              })}
              onClick={() => {
                scrollImagesToIndex(ind);
                scrollThumbnailsToIndex(ind);
                dispatchGalleryMonetateQEvent(
                  "ThumbnailItem",
                  modalMode,
                  undefined,
                );
              }}
              data-testid={`gallery:zoom:modal:thumbnails:thumbnail-${ind}`}
              aria-label={`Product Image ${ind + 1} of ${media.length}`}
            >
              <img
                src={formatAmplienceImageURL(
                  mediaItem.imageUrl + "?wid=640&hei=853",
                )}
                alt=""
                className={styles.thumbnailImage}
              />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
